<template>
  <div class="HomeBan">
    <swiper
      :modules="modules"
      :autoplay="{ delay: 5000, disableOnInteraction: false }"
      :loop="true"
      :pagination="{ clickable: true }"
      class="slider"
    >
      <swiper-slide class="item">
        <div class="info"><div class="lefttxt"></div></div>
        <div class="imgbox"><a href='/Technical2'><span style="background-image: url(static/picture/datu1.png);"></span></a></div>
      </swiper-slide>
      <swiper-slide class="item">
        <div class="info"><div class="lefttxt"></div></div>
        <div class="imgbox"><a href='/Technical1'><span style="background-image: url(static/picture/datu2.png);"></span></a></div>
      </swiper-slide>
      <swiper-slide class="item">
        <div class="info"><div class="lefttxt"></div></div>
        <div class="imgbox"><a href='/Technical3'><span style="background-image: url(static/picture/datu3.png);"></span></a></div>
      </swiper-slide>
      <swiper-slide class="item">
        <div class="info"><div class="lefttxt"></div></div>
        <div class="imgbox"><a href='/Technical4'><span style="background-image: url(static/picture/datu4.png);"></span></a></div>
      </swiper-slide>

      <!-- 自定义箭头 (Swiper 14 需要 SVG, 不能用空 div) -->
      <template #container-end>
        <div class="swiper-button-prev slick-prev-copy">
          <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
        </div>
        <div class="swiper-button-next slick-next-copy">
          <svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
        </div>
      </template>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css/bundle';

export default {
  name: 'HomeBan',
  components: { Swiper, SwiperSlide },
  data() {
    return { modules: [Autoplay, Pagination, Navigation] };
  }
};
</script>

<style scoped>
/* 用 Swiper 原生箭头样式，映射到原 slick class 名 */
.HomeBan .swiper-button-prev,
.HomeBan .swiper-button-next {
  color: rgba(255, 255, 255, 0.6);
  --swiper-navigation-size: 30px;
}
.HomeBan .swiper-button-prev:hover,
.HomeBan .swiper-button-next:hover {
  color: #fff;
}
</style>
